import React from "react";
import { useTranslation } from "react-i18next";
import { FaFile, FaLaptop } from "react-icons/fa";
import { LiaStarSolid } from "react-icons/lia";
import Profile from "../../../assets/profile3.png";
import Card from "../../AdminDashboard/Ad-StudentDashboard/Card";


const TeacherPortfolio2 = () => {
  const { t } = useTranslation();

  const card = [{
    profile: Profile,
    name: 'Sara Ali',
    charge: t("studentDash.homeTeacherPortfolio2.perHourCharge"),
    path:'../mentor-portfolio'
  }]

  
  return (
    <div className="m-3 flex flex-col break-words w-full mb-4 shadow-lg bg-white rounded-lg  border-0">
      <div className="flex items-center xl:p-5 sm:p-0 justify-center">
        <div className="w-full  xl:p-5 sm:p-0">

          <div className="p-3">
            <Card
              card={card}
/>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 ">
            <div className="   md:px-4 md:py-4 col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 space-y-5">
              
              <div className="border rounded-3xl shadow-xl p-5">
                <p className="text-2xl font-semibold mb-3">{t("studentDash.homeTeacherPortfolio.about")}</p>
                <p className="text-xs font-light">{t("studentDash.homeTeacherPortfolio2.loremLong")}</p>
              </div>

              <div className="border rounded-3xl shadow-xl p-5">
                <p className="text-2xl font-semibold mb-3">{t("studentDash.homeTeacherPortfolio.education")}</p>
                <div>
                  <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.loremShort")}</p>
                  <p className="text-sm font-light mb-3">{t("studentDash.homeTeacherPortfolio2.loremMedium")}</p>
                </div>
                <div>
                  <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.loremShort")}</p>
                  <p className="text-sm font-light mb-3">{t("studentDash.homeTeacherPortfolio2.loremMedium")}</p>
                </div>
                <div>
                  <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.loremShort")}</p>
                  <p className="text-sm font-light mb-3">{t("studentDash.homeTeacherPortfolio2.loremMedium")}</p>
                </div>
                <div>
                  <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.loremShort")}</p>
                  <p className="text-sm font-light mb-3">{t("studentDash.homeTeacherPortfolio2.loremMedium")}</p>
                </div>
              </div>

            </div>
            <div className="  col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 md:px-4 md:py-4 overflow-x-auto space-y-5 mt-5 md:mt-0">
              <div className="border rounded-3xl shadow-xl p-5">
                <p className="text-2xl font-semibold mb-2">{t("studentDash.homeTeacherPortfolio.skills")}</p>
                <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.loremList")}</p>
              </div>
              <div className="border rounded-3xl shadow-xl p-5">
                <p className="text-2xl font-semibold mb-3">{t("studentDash.homeTeacherPortfolio.profileOverview")}</p>

                <p className="flex text-yellow-400 items-center"><LiaStarSolid /><LiaStarSolid /><LiaStarSolid /><LiaStarSolid /><LiaStarSolid /> <span className="text-black">5.0</span></p>
                <div>
                  <div className="flex items-center text-base font-semibold space-x-1 mb-2">
                    <p className="text-lg"><FaLaptop /></p>
                    <p>{t("studentDash.homeTeacherPortfolio.homeTuitionLocation")}</p>
                  </div>
                  <div>
                    <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.loremList")}</p>
                  </div>
                </div>

              </div>
              <div className="border rounded-3xl shadow-xl p-5">
                <p className="text-2xl font-semibold mb-3">{t("studentDash.homeTeacherPortfolio.subjects")}</p>
                <div>
                  <div className="flex items-center text-base font-semibold space-x-1 mb-2">
                    <p className="text-lg"><FaFile /></p>
                    <p>{t("studentDash.homeTeacherPortfolio2.mainSubject")}</p>
                  </div>
                  <div>
                    <p className="text-sm font-semibold">{t("studentDash.homeTeacherPortfolio2.subjectName")}</p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherPortfolio2;
